import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AuthenticateService } from './shared/services/authenticate.service';
import { LoginService } from './shared/login-services/login.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomepageComponent } from './core/components/homepage/homepage.component';
import { AuthInterceptorService } from './shared/auth-interceptor.service';
import { UtilService } from './shared/helper/util.service';
import { AuthenticationService } from './shared/authentication.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { HomePageService } from './shared/services/homepage.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { FormatFileSizePipe } from './shared/services/FormatFileSizePipe.pipe';
import { AlertComponent } from './shared/alert/alert.component';
import { ToastComponent } from './shared/toast/toast.component';
import { ApplicationComponent } from './core/components/application/application.component';
import { AuthModule } from '@auth0/auth0-angular';
//import { environment } from 'src/environments/environment';
import { SuccessToastComponent } from './shared/success-toast/success-toast.component';
import { ErrorToastComponent } from './shared/error-toast/error-toast.component';
import { SubscriptionComponent } from './core/components/subscription/subscription.component';
import { ManageSubscriptionService } from './core/components/subscription/manage-subscription.service';
import { FooterComponent } from './core/components/footer/footer.component';
import { Base64Pipe } from './shared/convert-base64-img.pipe';
import { EditSubscriptionComponent } from './core/components/subscription/edit-subscription/edit-subs.component';
import { CreateSubscriptionService } from './core/components/subscription/edit-subscription/create-subscription.service';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { ConfirmEmailComponent } from './core/components/confirm-email/confirm-email.component';
import { CreatePasswordComponent } from './core/components/create-password/create-password.component';
import { ManageUsersComponent } from './core/components/manage-users/manage-users/manage-users.component';
import { CreateUserComponent } from './core/components/manage-users/create-user/create-user.component';
import { environment } from 'src/environments/environment.prod';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { EditUserComponent } from './core/components/manage-users/edit-user/edit-user.component';
import { LoginComponent } from './core/components/login/login.component';
import { ChangePasswordComponent } from './core/components/accout-settings/change-password/change-password.component';
import { EditProfileComponent } from './core/components/accout-settings/edit-profile/edit-profile.component';
import { AccoutSettingsComponent } from './core/components/accout-settings/accout-settings.component';
import { AnalyticsComponent } from './core/components/analytics/analytics.component';
import { DashboardDetailsComponent } from './core/components/analytics/dashboard-details/dashboard-details.component';
import { AnalyticsHomeComponent } from './core/components/analytics/analytics-home/analytics-home.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ViewAnalyticsComponent } from './core/components/view-analytics/view-analytics.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { RouterModule, RouterLink } from "@angular/router";
import { DataProductsComponent } from './core/components/data-products/data-products.component'
import { MyReportsComponent } from './core/components/data-products/my-reports/my-reports.component'
import { ProductsComponent } from './core/components/data-products/products/products.component';
import { ProductDetailsComponent } from './core/components/data-products/products/product-details/product-details.component'
import { DataProductsService } from './core/components/data-products/data-products.service';
import { TourGuideComponent }from './core/components/tour-guide/tour-guide.component';
import { HeaderV2Component } from './core/components/header-v2/header-v2.component';
import { AppDetailsComponent } from './core/components/application/app-details/app-details.component';
import { PageTransitionService } from './shared/services/pageTransition.service';
import { AppLoaderComponent } from "./core/components/app-loader/app-loader.component";
import { GuidedTourService } from './shared/services/guided-tour.service';
import { ManageRequestsComponent } from './core/components/manage-requests/manage-requests.component';
import { LibMultiSelectComponent } from './core/components/lib-multi-select/lib-multi-select.component';
import { A11yModule } from '@angular/cdk/a11y';
import { ManageRequestsService } from './core/components/manage-requests/manage-requests.service';
import { RequestAccessDialogComponent } from './shared/request-access-dialog/request-access-dialog.component';
import { ManageModulesComponent } from './core/components/manage-modules/manage-modules.component';
import { EditModuleComponent } from './core/components/manage-modules/edit-module/edit-module.component';
/*export const authConfig = environment.type.includes('qa')
  ? environment.indusAuth
  : environment.type.includes('uat')
  ? environment.uatAuth
  : environment.auth;*/
export const authConfig =  environment.auth;



@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    FormatFileSizePipe,
    AlertComponent,
    ToastComponent,
    ApplicationComponent,
    SuccessToastComponent,
    ErrorToastComponent,
    SubscriptionComponent,
    EditSubscriptionComponent,
    FooterComponent,
    Base64Pipe,
    ConfirmEmailComponent,
    CreatePasswordComponent,
    ManageUsersComponent,
    CreateUserComponent,
    EditUserComponent,
    AnalyticsComponent,
    DashboardDetailsComponent,
    LoginComponent,
    AccoutSettingsComponent,
    ChangePasswordComponent,
    EditProfileComponent,
    AnalyticsHomeComponent,
    ViewAnalyticsComponent,
    DataProductsComponent,
    MyReportsComponent,
    ProductsComponent,
    ProductDetailsComponent,
    HeaderV2Component,
    TourGuideComponent,
    AppDetailsComponent,
    ManageRequestsComponent,
    LibMultiSelectComponent,  
    RequestAccessDialogComponent,
    ManageModulesComponent,
    EditModuleComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule,
    RouterLink,
    HttpClientModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    AuthModule.forRoot(authConfig),
    AutocompleteLibModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatButtonModule,
    AppLoaderComponent,
    MatTooltipModule,
    PowerBIEmbedModule,
    A11yModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    AuthenticateService,
    LoginService,
    UtilService,
    AuthenticationService,
    HomePageService,
    ManageSubscriptionService,
    CreateSubscriptionService,
    DataProductsService,
    PageTransitionService,
    GuidedTourService,
    ManageRequestsService
  ],
  bootstrap: [AppComponent],
  exports: [TourGuideComponent]
})
export class AppModule {}
